export const API_KEY = 'AIzaSyDwWpmTNiEOLf7oS5zApFn30QliNZaYB_s';